/*
 * jQuery Maps
 * (all options can be set by data attributes)
 * (numeric map markers, custom infoboxes, location list opens boxes, average pan)
 *
 * Required SCRIPT:
 *  <script type='text/javascript' src='https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false'></script>
 *
 * Typical HTML:
 *  <div class='map' data-lat='53.367698' data-lng='-1.47302' data-zoomLevel='12'></div>
 *
 * Typical CSS:
 *  .map { width: 100%; height: 400px; }
 *
 * Copyright (c) 2012-2017 Michael Cook for Evoluted
 * Released under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 */

// let markers be accessable globally (even within webpack scoping)
window.markers = [];

(function($) {
    $.fn.extend({
        maps: function(options) {
            var defaults = {
                marker: false, // only if wanting a generic unstyled marker
                markerImage: '',
                markerDimensions: '', // e.g. [10,20]
                markerPoint: '', // Where the pinpoint on the marker is e.g. [10,20]
                zoomLevel: 14,
                mapTypeId: google.maps.MapTypeId.ROADMAP, // defaults to normal road map (can be set by data-mapTypeId)
                disableDefaultUI: true,
                panControl: true,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                overviewMapControl: false,
                zoomControlSize: '', // small, large, '' (default)
                directions: false,
                directionsStart: '', // e.g. $('.directions__postcode'); - it takes the .val()
                directionsEnd: '', // defaults to map marker point
                directionsRouteID: '', // Show driving route in an element of given id
                directionsButton: '', // e.g. $('.directions__button')
                scrollwheel: false, // disable scroll zooming (for mobile benefit - touchscreens)
                draggableOnMobiles: false, // disabled touch dragging map on mobiles
                controlsWrapperClass: '', // or just wrap manually
                locations: false,
                /* e.g.
				[
					{
						"latitude": 58.123,
						"longitude": -1.11
					},
					{
						"latitude": 58.123,
						"longitude": -1.11
					}
				]
				// They can also haven a url value which it will go to on click
				*/
                locationsArray: '',
                locationsInfoClass: '',
                locationAveragePan: false,
                addInteractedToClass: '', // if map is interacted with, add a class to given element
                runAfterInteractionTimeout: '',
                runAfterInteractionFunction: function() {}, // e.g. resizeThings (no brackets)
                centerOffsetLat: 0,
                centerOffsetLng: 0,
                suppressInfoWindows: false,
                infoBoxes: false,

                extraOptions: {}, // pass extra options straight into map options

                fitToBounds: false // Uses Googe Maps fit and zoom to markers functionality
            };

            var options = $.extend(defaults, options);

            var mapJquery,
                moved = 0,
                autoBounds = false,
                bounds;

            return this.each(function() {
                var map = $(this);
                var mapJquery = $(this);
                var infoBoxArray = [];

                /**
				 * Generic way of taking options by appropriately named data attributes
				 * Such as data-marker="true" data-markerPoint="[10,20]"
				 */
                for (var key in options) {
                    if (map.attr('data-' + key)) {
                        //console.log("data-"+key+": "+map.attr("data-"+key));
                        var value = map.attr('data-' + key);

                        // Handle parsing for certain cases
                        if (value == 'true') {
                            value = true;
                        }
                        if (value == 'false') {
                            value = false;
                        }
                        if (key == 'zoomLevel') {
                            value = parseFloat(value);
                        }
                        if (key == 'markerPoint' || key == 'markerDimensions') {
                            value = jQuery.parseJSON(value);
                        }
                        if (key == 'locationsArray') {
                            // This isn't getting the value right ?
                            /*
							// Example:
							value = '[{"latitude": 53.2650355, "longitude": -1.0278223 }, {"latitude": 53.2650355, "longitude": -1.0278223 } ]';
							*/
                            // Fix trailing comma (e.g. smarty sites)
                            if (value.slice(-2) == ',]') {
                                value = value.substring(0, value.length - 2) + ']';
                            }
                            value = jQuery.parseJSON(value);
                        }

                        options[key] = value;
                    }
                }

                // decide whether to user auto bounds for the map based on whether the options
                // toggle is set to true and no data-zoomLevel has been set on the map element
                if (
                    (typeof map.attr('data-zoomLevel') == 'undefined' || map.attr('data-zoomLevel') == '') &&
                    options.fitToBounds == true
                ) {
                    autoBounds = true;
                }

                // setup Google Maps bounds functionality when requested
                if (autoBounds) {
                    bounds  = new google.maps.LatLngBounds();
                }

                if (map.attr('data-lat') && map.attr('data-lng')) {
                    options.lat = parseFloat(map.attr('data-lat'));
                    options.lng = parseFloat(map.attr('data-lng'));

                    var latlng = new google.maps.LatLng(options.lat, options.lng);

                    if (autoBounds) {
                        // extend the bounds of the map to cover the newly added location
                        bounds.extend(latlng);
                    }

                    // Only for sandybrook/darwin (along with a lot of this stuff)
                    var center = new google.maps.LatLng(
                        options.lat + options.centerOffsetLat,
                        options.lng
                    );

                    if (map.attr('data-mapTypeId')) options.mapTypeId = map.attr('data-mapTypeId');

                    var myOptions = {
                        zoom: options.zoomLevel,
                        center: center,
                        mapTypeId: options.mapTypeId,
                        disableDefaultUI: options.disableDefaultUI,
                        panControl: options.panControl,
                        zoomControl: options.zoomControl,
                        mapTypeControl: options.mapTypeControl,
                        scaleControl: options.scaleControl,
                        streetViewControl: options.streetViewControl,
                        overviewMapControl: options.overviewMapControl,
                        scrollwheel: options.scrollwheel,
                        draggable: true, // changed via draggableOnMobiles
                        suppressInfoWindows: options.suppressInfoWindows
                    };

                    // these override any set positions which is a bit short sighted
                    if (options.zoomControlSize == 'large') {
                        myOptions['zoomControlOptions'] = {
                            style: google.maps.ZoomControlStyle.LARGE
                        };
                    } else if (options.zoomControlSize == 'small') {
                        myOptions['zoomControlOptions'] = {
                            style: google.maps.ZoomControlStyle.SMALL
                        };
                    } else {
                        myOptions['zoomControlOptions'] = {
                            style: google.maps.ZoomControlStyle.DEFAULT
                        };
                    }

                    // Disable touch dragging map on mobiles
                    if (options.draggableOnMobiles == false && $(window).width() <= 768) {
                        myOptions['draggable'] = false;
                    }

                    // merge extraOptions (right before creating map)
                    var myOptions = $.extend(myOptions, options.extraOptions);

                    map = new google.maps.Map(map[0], myOptions);
                    if (options.markerImage != '' && options.marker != false) {
                        if (options.markerDimensions == '' || options.markerPoint == '') {
                            console.log('Maps: markerDimensions and markerPoint must be set.');
                            return;
                        }
                        var image = new google.maps.MarkerImage(
                            options.markerImage,
                            new google.maps.Size(
                                options.markerDimensions[0],
                                options.markerDimensions[1]
                            ),
                            new google.maps.Point(0, 0),
                            new google.maps.Point(options.markerPoint[0], options.markerPoint[1])
                        );
                        var shape = {
                            coords: [
                                0,
                                0,
                                options.markerDimensions[0],
                                options.markerDimensions[1]
                            ],
                            type: 'rect'
                        };

                        var marker = new google.maps.Marker({
                            clickable: false, // set (at least the initial) marker to be unclickable
                            draggable: false,
                            icon: image,
                            shape: shape,
                            map: map,
                            position: latlng
                        });
                    } else if (
                        options.marker == true &&
                        options.markerImage == '' &&
                        options.markerDimensions == '' &&
                        options.markerPoint == ''
                    ) {
                        // Generic marker with no customisation
                        var marker = new google.maps.Marker({
                            clickable: false, // set (at least the initial) marker to be unclickable
                            draggable: false,
                            map: map,
                            position: latlng
                        });
                    }

                    // Map directions
                    if (options.directions == true) {
                        if (options.directionsButton == '') {
                            console.log('Maps: directionsButton must be set.');
                            return;
                        } else {
                            options.directionsButton.click(function() {
                                loadDirections(map, latlng);
                            });
                        }

                        if (options.directionsStart == '') {
                            console.log(
                                'Maps: directionsStart must be set as the jQuery object of an input element.'
                            );
                            return;
                        } else {
                            options.directionsStart.keyup(function(e) {
                                if (e.keyCode == 13) {
                                    // return or enter
                                    loadDirections(map, latlng);
                                }
                            });
                        }
                    }

                    // Wrap the map controls in a div
                    if (options.controlsWrapperClass != '') {
                        google.maps.event.addDomListener(map, 'tilesloaded', function() {
                            if ($('.' + options.controlsWrapperClass).length == 0) {
                                $('div.gmnoprint')
                                    .last()
                                    .parent()
                                    .wrap('<div class="' + options.controlsWrapperClass + '" />');
                                var wrapper = $('.' + options.controlsWrapperClass);
                                wrapper.fadeIn(500);
                            }
                        });
                    } else $('div.gmnoprint').fadeIn(500); // fade controls in (set .gmnoprint as display: none in css)

                    // Display given array of locations on map
                    if (options.locations == true) {
                        if (options.locationsArray == '') {
                            console.log('Maps: locationsArray must be set.');
                            return;
                        }

                        for (var i = 0; i < options.locationsArray.length; i++) {
                            addLocation(
                                map,
                                window.markers,
                                options.locationsArray,
                                options.locationsArray[i],
                                i
                            );
                        }
                    }

                    // Must have height and width set - use these if no css available
                    if ($(this).css('height') == '0px') {
                        $(this).height('100%').width('100%').css('min-height', 300);
                    }

                    // clicking map closes any infoboxes
                    if (options.infoBoxes != false) {
                        google.maps.event.addListener(map, 'click', function() {
                            closeInfoBoxes();
                        });

                        // location buttons open respective infoboxes and pan map
                        if (options.locationMarkers == true) {
                            $('.location').length &&
                                $('.location').click(function() {
                                    closeInfoBoxes();
                                    openBox(map, window.markers, $(this).attr('data-infoID'));
                                });
                        }
                    }
                }

                // When fitToBounds is toggled, the map can be auto zoomed
                // and auto centered based on the marker bounds incremented
                // whenever a new map marker is added
                if (autoBounds) {
                    map.fitBounds(bounds); // auto-zoom
                    map.panToBounds(bounds); // auto-center
                } else {
                    // Pan to the average center of all the map marker locations
                    if (options.locationAveragePan == true) {
                        var averageLat = (averageLng = 0);
                        for (var i = 0; i < options.locationsArray.length; i++) {
                            averageLat += options.locationsArray[i].latitude;
                            averageLng += options.locationsArray[i].longitude;
                        }
                        averageLat /= options.locationsArray.length;
                        averageLng /= options.locationsArray.length;

                        var averageLatLng = new google.maps.LatLng(averageLat, averageLng);

                        map.panTo(averageLatLng);
                    }
                }
            });

            function closeInfoBoxes() {
                for (var i = 0; i < infoBoxArray.length; i++) {
                    infoBoxArray[i].close();
                }
            }

            function addLocation(map, markers, locationsArray, location, i, open) {
                // Create a new location
                var loc = new google.maps.LatLng(location.latitude, location.longitude);

                if (autoBounds) {
                    // extend the bounds of the map to cover the newly added location
                    bounds.extend(loc);
                }

                // Create the marker options
                var markerOptions = {
                    draggable: false,
                    map: map,
                    position: loc
                };

                // By default this uses same map marker dimensions and pinpoint as original marker
                if (options.markerDimensions != '' && options.markerPoint != '') {
                    if (location.marker == undefined) location.marker = options.markerImage;

                    var image = new google.maps.MarkerImage(
                        location.marker,
                        new google.maps.Size(
                            options.markerDimensions[0],
                            options.markerDimensions[1]
                        ),
                        new google.maps.Point(0, 0),
                        new google.maps.Point(options.markerPoint[0], options.markerPoint[1])
                    );
                    var shape = {
                        coords: [0, 0, options.markerDimensions[0], options.markerDimensions[1]],
                        type: 'rect'
                    };

                    markerOptions['icon'] = image;
                    markerOptions['shape'] = shape;
                }
                // Add the marker on map
                var marker = new google.maps.Marker(markerOptions);
                if (location.infoID) marker.infoID = location.infoID;

                if (options.infoBoxes == true) {
                    infoBoxArray.push(
                        new InfoBox({
                            disableAutoPan: false,
                            zIndex: null,
                            pixelOffset: new google.maps.Size(-(340 / 2), -46),
                            infoBoxClearance: new google.maps.Size(1, 1)
                        })
                    );

                    google.maps.event.addListener(marker, 'click', function() {
                        closeInfoBoxes();
                        openBox(map, markers, marker.infoID);
                    });
                }

                // If location has an 'url' value, go to it on click
                if (location.url != null) {
                    google.maps.event.addListener(marker, 'click', function() {
                        window.location.href = location.url;
                    });
                }

                // Add marker to array (for clearing)
                window.markers.push(marker);
            }

            function openBox(map, markers, infoID) {
                for (var n = 0; n < markers.length; n++) {
                    if (markers[n].infoID == infoID) {
                        foundMarker = markers[n];
                    }
                }

                for (var n = 0; n < options.locationsArray.length; n++) {
                    if (options.locationsArray[n].infoID == infoID) {
                        foundLocation = options.locationsArray[n];
                    }
                }

                var infoBox = infoBoxArray[infoID - 1]; // ropey

                var loc = new google.maps.LatLng(foundLocation.latitude, foundLocation.longitude);

                infoBox.open(map, foundMarker);

                var html =
                    "\
					<div class='map__infobox'>\
						<div class='map__infobox__content'>\
							<div class='has-icon'>\
								<h3>" +
                    foundLocation.name +
                    '</h3>\
								<p>' +
                    foundLocation.address +
                    '</p>\
							</div>\
						</div>\
					</div>\
				';
                infoBox.setContent(html);

                map.panTo(loc);

                // By default, marker pin is at the center of the map, but we'll pan it down
                // so that the infobox and marker (arbitrary amount) are centered.
                // Make it check at intervals for the content height to use for panning:
                // When it's found, do the panning and stop interval, or after a short time anyway.
                var panInterval = setInterval(function() {
                    var infoBoxHeight = $('.map__infobox').height();
                    if (infoBoxHeight > 0) {
                        clearInterval(panInterval);
                        map.panBy(0, -(infoBoxHeight + 30) / 2);
                    }
                }, 20);
                // Just in case
                setTimeout(function() {
                    clearInterval(panInterval);
                }, 500);
            }

            function resetMarkerIcons(markers, locationsArray) {
                // Reset all marker icons
                for (var i = 0; i < markers.length; i++) {
                    var image = new google.maps.MarkerImage(
                        locationsArray[i].marker,
                        new google.maps.Size(
                            options.markerDimensions[0],
                            options.markerDimensions[1]
                        ),
                        new google.maps.Point(0, 0),
                        new google.maps.Point(options.markerPoint[0], options.markerPoint[1])
                    );

                    markers[i].setIcon(image);
                }
            }

            function markerListen(map, locationsArray, markers, marker, i, location) {
                // Show location name when hovering over
                google.maps.event.addListener(marker, 'mouseover', function() {
                    // Delete any labels
                    $('.map-label').remove();

                    var labelText = locationsArray[i].name;

                    // Figure out the pixel position of the marker
                    var scale = Math.pow(2, map.getZoom());
                    var nw = new google.maps.LatLng(
                        map.getBounds().getNorthEast().lat(),
                        map.getBounds().getSouthWest().lng()
                    );
                    var worldCoordinateNW = map.getProjection().fromLatLngToPoint(nw);
                    var worldCoordinate = map
                        .getProjection()
                        .fromLatLngToPoint(marker.getPosition());
                    var pixelOffset = new google.maps.Point(
                        Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
                        Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale)
                    );

                    var top = pixelOffset.y;
                    var left = pixelOffset.x;

                    // increase position relative to position of the map
                    top += mapJquery.offset().top;
                    left += mapJquery.offset().left;

                    var el = $(
                        '<div class="map-label" style="position: absolute; top: ' +
                            top +
                            'px; left: ' +
                            left +
                            'px;">' +
                            labelText +
                            '</div>'
                    );

                    $('body').prepend(el);

                    // Nudge to centralise itself
                    var marginLeft = -Math.round(el.outerWidth() / 2);
                    el.css('margin-left', marginLeft + 'px');
                    el.css('margin-top', '-35px');

                    // Set a timer to remove it eventually
                    setTimeout(function() {
                        el.remove();
                    }, 500);

                    // Bind label click event to same as matching marker
                    el.click(function() {
                        markerClickEvent(markers, marker, location, locationsArray);
                    });
                });

                google.maps.event.addListener(marker, 'mouseout', function() {});

                google.maps.event.addListener(marker, 'click', function() {
                    markerClickEvent(map, markers, marker, location, locationsArray);
                });
            }

            function markerClickEvent(map, markers, marker, location, locationsArray) {
                resetMarkerIcons(markers, locationsArray);

                // Only for sandybrook/darwin (along with a lot of this stuff)
                var center = new google.maps.LatLng(
                    options.lat + options.centerOffsetLat,
                    options.lng + options.centerOffsetLng
                );

                // Set active state marker icon
                if (location.markerActive != undefined) {
                    var image = new google.maps.MarkerImage(
                        location.markerActive,
                        new google.maps.Size(
                            options.markerDimensions[0],
                            options.markerDimensions[1]
                        ),
                        new google.maps.Point(0, 0),
                        new google.maps.Point(options.markerPoint[0], options.markerPoint[1])
                    );

                    marker.setIcon(image);
                }

                if (options.locationsInfoClass != '') {
                    $('.' + options.locationsInfoClass).stop().fadeOut(500);
                    $(
                        '.' + options.locationsInfoClass + '[data-infoID=' + location.infoID + ']'
                    ).fadeIn(500);
                }

                // Add the interacted class when something is clicked
                if (options.addInteractedToClass != '') {
                    $('.' + options.addInteractedToClass).addClass('interacted');

                    // a function can be run after a given timeout when interaction is made (i.e. resizeThings)
                    if (options.runAfterInteractionTimeout != '') {
                        setTimeout(function() {
                            options.runAfterInteractionFunction.call(this);
                        }, options.runAfterInteractionTimeout);
                    }
                }
            }

            function loadDirections(map, latlng) {
                if (options.directionsRouteID == '' || !$('#' + options.directionsRouteID).length) {
                    console.log('Maps: directionsRouteID must be set to the ID of a div.');
                    return;
                }

                if (options.directionsStart.val() == '') {
                    $('#' + options.directionsRouteID).html(
                        "<p class='map__error'>Please input an address.</p>"
                    );
                    return;
                }

                var directionsService = new google.maps.DirectionsService();

                // By default, use the given map lat long as the direction end point
                if (options.directionsEnd == '') {
                    options.directionsEnd = latlng;
                }

                // THIS LINE BELOW must be run only once
                // create map render and stop the default marker appearing
                // var directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers: true});
                if (directionsDisplay == '' || directionsDisplay == undefined) {
                    directionsRendererOptions = {
                        polylineOptions: {
                            strokeColor: '#00b3fd',
                            strokeWeight: 5,
                            visible: true
                        }
                    };
                    // If custom marker, suppress the original ones
                    if (options.markerImage != '') {
                        directionsRendererOptions['suppressMarkers'] = true;
                    }
                    var directionsDisplay = new google.maps.DirectionsRenderer(
                        directionsRendererOptions
                    );
                }

                directionsDisplay.setMap(map);

                if (options.directionsRouteID != '') {
                    // Show driving route in an element of given id
                    $('#' + options.directionsRouteID).empty(); // this only works if DirectionsRenderer is only set the once.
                    directionsDisplay.setPanel(document.getElementById(options.directionsRouteID));
                }

                var request = {
                    origin: options.directionsStart.val(),
                    destination: options.directionsEnd,
                    travelMode: google.maps.TravelMode.DRIVING
                };

                directionsService.route(request, function(response, status) {
                    // Show error if it didn't work
                    if (options.directionsRouteID != '') {
                        if (response && response.status == 'NOT_FOUND') {
                            $('#' + options.directionsRouteID).html(
                                "<p class='map__error'>Address not found.</p>"
                            );
                        } else {
                            $('#' + options.directionsRouteID).html();
                        }
                    }

                    if (status == google.maps.DirectionsStatus.OK) {
                        directionsDisplay.setDirections(response);
                    }
                });
            }
        }
    });
})(jQuery);
